// extracted by mini-css-extract-plugin
export default {"nav_link":"CustomNavLink_nav_link__XHup0"};